import { easeCubic } from 'd3-ease';
import React from 'react';
import { Animate } from 'react-move';

import useCommonContext from './hooks/useCommonContext';

const Component = props => {
  const { width, height } = useCommonContext();
  return (
    <defs>
      <Animate
        key={width + '-' + height}
        start={() => {
          return {
            wipeWidth: 0,
          };
        }}
        enter={() => {
          return {
            wipeWidth: [width],
            timing: { delay: 200, duration: 1200, ease: easeCubic },
          };
        }}
      >
        {state => {
          const { wipeWidth } = state;
          return (
            <mask id='wipe'>
              <rect x={0} y={0} width={width} height={height} fill='black' />
              <rect
                x={0}
                y={0}
                width={wipeWidth}
                height={height}
                fill='white'
              />
            </mask>
          );
        }}
      </Animate>
    </defs>
  );
};

export default Component;
